module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAARCAYAAAAR3bZVAAAAAXNSR0IArs4c6QAAASVJREFUKFNtkbFLw1AQxu8SNwevgnsR1MnNQVTQwamJWocu7uKks5CnhJJI6SSCi5uTuGpS6NSpCBJ0chP/BF/Eodq+vJNEWozNbXe/74O77zB2KkvktyIoKJSO9WIkameq0X79z/FdVA4Q8Yi+zWVs3n3+FWDaSGFdAGKZzKCKLuihIINcq5lyodcyGCPy750czNxulXigHgwAl/zgNp1lzmF9CHtOA3RQD7bprP2Ug6koFtYmA17RV39xDEp3gyCZfFaJWsnBbLH5XmggR+SFIgelsM+BuUx+uIsAPIKxsPcZ4FD15epMs5uF8RvCydY6sL5BBWvUCN9Gd8bH1qyewC4avFeqh51cfLGwHzXA9bQXXI4FL4VdL3nBaeHLGADTzYrgD31qbZthzb5UAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/youjiantou.png
// module id = FAuW
// module chunks = 26